import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonUiModule } from '../common-ui.module';
import { ChatCloseIconComponent } from '../icons/chat-close-icon/chat-close-icon.component';
import { ChatMessagesIconComponent } from '../icons/chat-message-icon/chat-messages-icon.component';

@Component({
  selector: 'common-toggle-chat-button',
  standalone: true,
  imports: [CommonModule, CommonUiModule, ChatCloseIconComponent, ChatMessagesIconComponent],
  templateUrl: './toggle-chat-button.component.html',
  styleUrl: './toggle-chat-button.component.scss',
})
export class ToggleChatButtonComponent {
  @Output() emitToggleChat = new EventEmitter<void>();
  @Input() contained = false;
  @Input() closeIcon = false;
  @Input() messageIcon = false;
  @Input() hasNewMessage = false;
  @Input() showInitialPreviewMessage = false;
  @Input() trackablePrefix?: string;
  @Input() position: 'bottomRight' | 'bottomLeft' = 'bottomRight';
  @Output() emitClosePreview = new EventEmitter<void>();

  toggleChat() {
    this.emitToggleChat.emit();
  }

  onClosePreview() {
    this.emitClosePreview.emit();
    this.showInitialPreviewMessage = false;
  }
}
